import {EEquipmentType} from "../utils/EEquipmentType";
import {AElement} from "../elements/AElement";
import {ISpecifications} from "../utils/ISpecifications";

export abstract class AEquipment {

    private _type: EEquipmentType;
    private _elements: AElement[];
    private _specifications: ISpecifications[];

    protected constructor(type: EEquipmentType, elements: AElement[], specifications: ISpecifications[]) {
        this._type = type;
        this._elements = elements;
        this._specifications = specifications;
    }

    get type(): EEquipmentType {
        return this._type;
    }

    set type(value: EEquipmentType) {
        this._type = value;
    }

    get elements(): AElement[] {
        return this._elements;
    }

    set elements(value: AElement[]) {
        this._elements = value;
    }

    get specifications(): ISpecifications[] {
        return this._specifications;
    }

    set specifications(value: ISpecifications[]) {
        this._specifications = value;
    }

    private areElementsCorrect(): boolean {
        let areCorrect = true;
        for(let i = 0; i < this.elements.length; i++) {
            if(!this.elements[i].isCorrect()) {
                areCorrect = false;
                break;
            }
        }
        return areCorrect;
    }

    private areElementsAccordanceWithSpecifications(): boolean {
        let areAccordance = true;
        for(let i = 0; i < this.specifications.length; i++) {
            const currentSpecs = this.specifications[i];
            const elements = this.elements.filter(element => element.type === currentSpecs.type);
            if(elements.length !== currentSpecs.quantity) {
                areAccordance = false;
                break;
            }
        }
        return areAccordance;
    }


    public isCorrect(): boolean {
        return (
            this.type in EEquipmentType &&
            this.areElementsCorrect() &&
            this.areElementsAccordanceWithSpecifications()
        );
    }
}
